
const messages = {
  policy: 'If you are interested in booking an appointment with Johannes, please fill out the following ' +
          'request form. Once your form is received, you will be contacted within 5 business days to ' +
          'confirm your appointment. In order to book your appointment, an $80 deposit is required (via ' +
          'PayPal) within 24 hours of confirmation. This deposit is non-refundable and will go towards ' +
          'the cost of your tattoo. Please include any relevant information, reference materials, or ' +
          'other details in your form. Deposits for rescheduling with less than 48-hour notice ' +
          'and failing to bring proper identification will be forfeit. We look forward to working with you!',
}

export default messages;



// WEBPACK FOOTER //
// ./client/components/Booking/Policy/messages.js